import React from "react";
import styles from "./notifications.module.scss";

interface NotificationPreviewProps {
  title: string;
  body: string;
}

const NotificationPreview: React.FC<NotificationPreviewProps> = ({ title, body }) => (
  <aside className={styles["notification-preview"]} aria-label="Live notification preview">
    <div className={styles["notification-preview__label"]}>Live preview</div>
    <div className={styles["notification-preview__card"]}>
      <div className={styles["notification-preview__app-icon"]}>MM</div>
      <div className={styles["notification-preview__copy"]}>
        <div className={styles["notification-preview__app-name"]}>MamiMarkets</div>
        <strong>{title.trim() || "Your notification title"}</strong>
        <p>{body.trim() || "Your notification message will appear here."}</p>
      </div>
    </div>
  </aside>
);

export default NotificationPreview;
